import { render } from "./News6.vue?vue&type=template&id=1713432d"
import script from "./News6.vue?vue&type=script&lang=js"
export * from "./News6.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__